export default "https://assets.pclncdn.com/web/next-landing/80a0a33/_next/static/images/hotel-vip-promo-2x-b68b6b81b0ae53d5e22cdf21987fec4f.webp";